import { render, staticRenderFns } from "./Sfsypc.vue?vue&type=template&id=4bd221d3&scoped=true"
import script from "./Sfsypc.vue?vue&type=script&lang=js"
export * from "./Sfsypc.vue?vue&type=script&lang=js"
import style0 from "./Sfsypc.vue?vue&type=style&index=0&id=4bd221d3&prod&lang=scss&scoped=true"
import style1 from "./Sfsypc.vue?vue&type=style&index=1&id=4bd221d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd221d3",
  null
  
)

export default component.exports